(function () {
	var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	function syncBodyLock() {
		var shouldLock = document.body.classList.contains("mobilemenuopen") || document.body.classList.contains("ns-cart-open");
		document.body.style.overflow = shouldLock ? "hidden" : "";
	}

	function setMobileMenu(open) {
		var burger = document.getElementById("site-burger");
		document.body.classList.toggle("mobilemenuopen", open);
		if (burger) burger.setAttribute("aria-expanded", open ? "true" : "false");
		syncBodyLock();
	}

	function initHero() {
		var hero = document.getElementById("hero");
		if (!hero) return;

		var video = hero.querySelector(".hero-video");

		if (video && video.play) {
			var playPromise = video.play();
			if (playPromise && typeof playPromise.catch === "function") {
				playPromise.catch(function () {});
			}
		}

		window.requestAnimationFrame(function () {
			document.body.classList.add("is-ready");
			hero.classList.add("is-ready");
		});
	}

	function initHeroLogoPosition() {
		var hero = document.getElementById("hero");
		if (!hero) return;

		var ticking = false;

		function syncHeroLogoPosition() {
			var heroRect = hero.getBoundingClientRect();
			document.body.classList.toggle("hero-logo-centered", heroRect.bottom > 96);
			ticking = false;
		}

		function requestHeroLogoSync() {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(syncHeroLogoPosition);
		}

		window.addEventListener("scroll", requestHeroLogoSync, { passive: true });
		window.addEventListener("resize", requestHeroLogoSync);
		syncHeroLogoPosition();
	}

	function initMobileMenu() {
		var burger = document.getElementById("site-burger");
		var scrim = document.getElementById("site-nav-scrim");
		if (!burger) return;

		burger.addEventListener("click", function () {
			setMobileMenu(!document.body.classList.contains("mobilemenuopen"));
		});

		if (scrim) {
			scrim.addEventListener("click", function () {
				setMobileMenu(false);
			});
		}

		window.addEventListener("resize", function () {
			if (window.innerWidth > 767.5) setMobileMenu(false);
		});
	}

	function initSmoothScroll() {
		document.querySelectorAll("[data-scroll]").forEach(function (link) {
			link.addEventListener("click", function (event) {
				var targetId = this.getAttribute("href");
				if (!targetId || targetId.charAt(0) !== "#") return;

				var target = document.querySelector(targetId);
				if (!target) return;

				event.preventDefault();
				setMobileMenu(false);
				target.scrollIntoView({
					behavior: prefersReducedMotion ? "auto" : "smooth",
					block: "start"
				});
			});
		});
	}

	function initReveals() {
		var revealItems = document.querySelectorAll(".reveal");
		var productCards = document.querySelectorAll(".ns-product-card");

		if (!("IntersectionObserver" in window) || prefersReducedMotion) {
			revealItems.forEach(function (item) {
				item.classList.add("is-visible");
			});

			productCards.forEach(function (card) {
				card.classList.add("ns-card-visible");
			});
			return;
		}

		var revealObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				entry.target.classList.add("is-visible");
				observer.unobserve(entry.target);
			});
		}, {
			threshold: 0.16,
			rootMargin: "0px 0px -8% 0px"
		});

		revealItems.forEach(function (item) {
			revealObserver.observe(item);
		});

		var cardObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;

				var card = entry.target;
				var siblings = Array.prototype.slice.call(card.parentNode.children);
				var index = siblings.indexOf(card);

				window.setTimeout(function () {
					card.classList.add("ns-card-visible");
				}, index * 80);

				observer.unobserve(card);
			});
		}, {
			threshold: 0.18,
			rootMargin: "0px 0px -10% 0px"
		});

		productCards.forEach(function (card) {
			cardObserver.observe(card);
		});
	}

	function initHeaderContrast() {
		var header = document.getElementById("site-header");
		var lightZones = Array.prototype.slice.call(document.querySelectorAll(".light-zone"));
		if (!header || !lightZones.length) return;

		var ticking = false;

		function syncHeaderContrast() {
			var headerRect = header.getBoundingClientRect();
			var probeY = headerRect.top + Math.min(headerRect.height, 64) - 10;
			var onLight = false;

			for (var i = 0; i < lightZones.length; i++) {
				var rect = lightZones[i].getBoundingClientRect();
				if (rect.top <= probeY && rect.bottom >= probeY) {
					onLight = true;
					break;
				}
			}

			document.body.classList.toggle("header-on-light", onLight);
			ticking = false;
		}

		function requestSync() {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(syncHeaderContrast);
		}

		window.addEventListener("scroll", requestSync, { passive: true });
		window.addEventListener("resize", requestSync);
		requestSync();
	}

	function initRotators() {
		var rotators = document.querySelectorAll(".ns-loop-phrases");
		if (!rotators.length) return;

		function measureRotator(rotator) {
			var items = rotator._loopItems || [];
			var maxHeight = 0;

			items.forEach(function (item) {
				maxHeight = Math.max(maxHeight, item.offsetHeight);
			});

			if (maxHeight) rotator.style.minHeight = maxHeight + "px";
		}

		function showPhrase(rotator, index) {
			var items = rotator._loopItems || [];
			items.forEach(function (item, itemIndex) {
				item.classList.toggle("active", itemIndex === index);
			});
			rotator._loopIndex = index;
			measureRotator(rotator);
		}

		function initRotator(rotator) {
			if (rotator.getAttribute("data-loop-init") === "true") return;

			var items = Array.prototype.slice.call(rotator.querySelectorAll("li"));
			if (!items.length) return;

			rotator.setAttribute("data-loop-init", "true");
			rotator._loopItems = items;
			rotator._loopIndex = 0;
			rotator.classList.add("rotatorReady");

			measureRotator(rotator);
			showPhrase(rotator, 0);

			if (prefersReducedMotion || items.length < 2) return;

			var delay = parseFloat(rotator.getAttribute("data-rotate-delay") || "2.2");
			if (isNaN(delay) || delay < 0.8) delay = 2.2;

			rotator._loopTimer = window.setInterval(function () {
				var nextIndex = rotator._loopIndex + 1;
				if (nextIndex >= rotator._loopItems.length) nextIndex = 0;
				showPhrase(rotator, nextIndex);
			}, delay * 1000);
		}

		rotators.forEach(initRotator);

		window.addEventListener("resize", function () {
			window.clearTimeout(window.__nsRotatorResizeTimer);
			window.__nsRotatorResizeTimer = window.setTimeout(function () {
				rotators.forEach(measureRotator);
			}, 120);
		});
	}

	function initCart() {
		var cart = [];
		var CART_STORAGE_KEY = "ns_cart_v6";
		try {
			cart = JSON.parse(localStorage.getItem(CART_STORAGE_KEY)) || [];
		} catch (e) {
			cart = [];
		}

		function saveCart() {
			try {
				localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
			} catch (e) {}
		}

		var openBtn = document.getElementById("ns-cart-open");
		var closeBtn = document.getElementById("ns-cart-close");
		var overlay = document.getElementById("ns-cart-overlay");
		var drawer = document.getElementById("ns-cart-drawer");
		var countEl = document.getElementById("ns-cart-count");
		var itemsEl = document.getElementById("ns-cart-items");
		var footerEl = document.getElementById("ns-cart-footer");
		var totalEl = document.getElementById("ns-cart-total-amount");
		var subtotalEl = document.getElementById("ns-cart-subtotal-amount");
		var shippingEl = document.getElementById("ns-cart-shipping-amount");
		var toastEl = null;
		var toastTimer = 0;
		var pulseTimer = 0;
		var CART_SHIPPING_FEE = 30;
		var CART_FREE_SHIPPING_SUBTOTAL = 259;
		var DEFAULT_SHIPPING_FEE = 30;
		var DEFAULT_SHIPPING_FREE_FROM = 3;
		var MAX_QTY = 4;
		var FALLBACK_TIER_PRICES = { 1: 149, 2: 250, 3: 259, 4: 299 };

		function sanitizeId(value) {
			if (value === undefined || value === null) return "";
			var normalized = String(value).trim();
			if (!normalized || normalized === "undefined" || normalized === "null") return "";
			return normalized;
		}

		function sanitizePrice(value) {
			var normalized = parseFloat(value);
			if (isNaN(normalized) || normalized < 0) return 0;
			return Math.round(normalized * 100) / 100;
		}

		function formatPrice(value) {
			var normalized = sanitizePrice(value);
			if (Math.abs(normalized - Math.round(normalized)) < 0.001) return String(Math.round(normalized));
			return normalized.toFixed(2).replace(".", ",");
		}

		function hasProvidedValue(value) {
			return value !== undefined && value !== null && String(value).trim() !== "";
		}

		function normalizeTierIds(rawTierIds, fallbackId) {
			rawTierIds = rawTierIds || {};
			var baseId = sanitizeId(rawTierIds[1]) || sanitizeId(fallbackId);
			return {
				1: baseId,
				2: sanitizeId(rawTierIds[2]) || baseId,
				3: sanitizeId(rawTierIds[3]) || baseId,
				4: sanitizeId(rawTierIds[4]) || baseId
			};
		}

		function getTierIdByQty(tierIds, qty) {
			qty = parseInt(qty, 10);
			if (isNaN(qty) || qty < 1) qty = 1;
			if (qty > MAX_QTY) qty = MAX_QTY;
			return sanitizeId(tierIds && tierIds[qty]) || sanitizeId(tierIds && tierIds[1]);
		}

		function normalizeTierPrices(rawTierPrices, fallbackPrice) {
			rawTierPrices = rawTierPrices || {};
			var basePrice = sanitizePrice(rawTierPrices[1]);
			if (!basePrice) basePrice = sanitizePrice(fallbackPrice);
			if (!basePrice) basePrice = FALLBACK_TIER_PRICES[1];
			return {
				1: basePrice,
				2: sanitizePrice(rawTierPrices[2]) || basePrice,
				3: sanitizePrice(rawTierPrices[3]) || basePrice,
				4: sanitizePrice(rawTierPrices[4]) || basePrice
			};
		}

		function getTierPriceByQty(tierPrices, qty) {
			qty = parseInt(qty, 10);
			if (isNaN(qty) || qty < 1) qty = 1;
			if (qty > MAX_QTY) qty = MAX_QTY;
			var fallback = FALLBACK_TIER_PRICES[qty] || FALLBACK_TIER_PRICES[1];
			return sanitizePrice(tierPrices && tierPrices[qty]) || fallback;
		}

		function normalizeShippingConfig(rawFee, rawFreeFrom) {
			var parsedFee = parseFloat(rawFee);
			var fee = hasProvidedValue(rawFee) && !isNaN(parsedFee) && parsedFee >= 0
				? sanitizePrice(rawFee)
				: DEFAULT_SHIPPING_FEE;

			var freeFrom = parseInt(rawFreeFrom, 10);
			if (isNaN(freeFrom) || freeFrom < 1) freeFrom = DEFAULT_SHIPPING_FREE_FROM;

			return {
				fee: fee,
				freeFrom: freeFrom
			};
		}

		function getShippingFeeForItem(item) {
			var shipping = normalizeShippingConfig(item.shippingFee, item.shippingFreeFrom);
			if (shipping.fee <= 0) return 0;
			if (item.qty >= shipping.freeFrom) return 0;
			return shipping.fee;
		}

		function getShippingLabelForQty(product, qty) {
			var shipping = normalizeShippingConfig(product.shippingFee, product.shippingFreeFrom);
			if (shipping.fee <= 0 || qty >= shipping.freeFrom) return "livraison gratuite";
			return "livraison " + formatPrice(shipping.fee) + " DH";
		}

		function buildTierIdsFromCard(card) {
			var fallbackId = card.getAttribute("data-id-1") || card.getAttribute("data-id");
			return normalizeTierIds({
				1: card.getAttribute("data-id-1"),
				2: card.getAttribute("data-id-2"),
				3: card.getAttribute("data-id-3"),
				4: card.getAttribute("data-id-4")
			}, fallbackId);
		}

		function buildTierPricesFromCard(card) {
			var fallbackPrice = card.getAttribute("data-price-1") || card.getAttribute("data-price");
			return normalizeTierPrices({
				1: card.getAttribute("data-price-1"),
				2: card.getAttribute("data-price-2"),
				3: card.getAttribute("data-price-3"),
				4: card.getAttribute("data-price-4")
			}, fallbackPrice);
		}

		function buildShippingFromCard(card) {
			return normalizeShippingConfig(
				card.getAttribute("data-shipping-fee"),
				card.getAttribute("data-shipping-free-from")
			);
		}

		function normalizeCartItem(rawItem) {
			if (!rawItem) return null;
			var qty = parseInt(rawItem.qty, 10);
			if (isNaN(qty)) qty = 1;
			if (qty < 1) qty = 1;
			if (qty > MAX_QTY) qty = MAX_QTY;

			var tierIds = normalizeTierIds(rawItem.tierIds, rawItem.id);
			var tierPrices = normalizeTierPrices(rawItem.tierPrices, rawItem.price);
			var shipping = normalizeShippingConfig(rawItem.shippingFee, rawItem.shippingFreeFrom);
			var id = sanitizeId(rawItem.id) || getTierIdByQty(tierIds, qty);
			var baseId = sanitizeId(rawItem.baseId) || getTierIdByQty(tierIds, 1) || id;
			var price = sanitizePrice(rawItem.price) || getTierPriceByQty(tierPrices, qty);

			return {
				id: id,
				baseId: baseId,
				name: rawItem.name || "Produit",
				price: price,
				img: rawItem.img || "",
				qty: qty,
				tierIds: tierIds,
				tierPrices: tierPrices,
				shippingFee: shipping.fee,
				shippingFreeFrom: shipping.freeFrom
			};
		}

		function isDealTierItem(item) {
			if (!item || item.qty <= 1) return false;
			var selectedId = sanitizeId(item.id) || getTierIdByQty(item.tierIds, item.qty);
			var baseId = getTierIdByQty(item.tierIds, 1);
			return !!selectedId && !!baseId && selectedId !== baseId;
		}

		function getCheckoutQty(item) {
			var checkoutQty = isDealTierItem(item) ? 1 : item.qty;
			if (checkoutQty < 1) checkoutQty = 1;
			return checkoutQty;
		}

		function buildGroupedCheckoutItems(items) {
			var groupedItems = {};
			(items || []).forEach(function (rawItem) {
				var item = normalizeCartItem(rawItem);
				if (!item) return;
				var id = sanitizeId(item.id);
				if (!id) return;
				groupedItems[id] = (groupedItems[id] || 0) + getCheckoutQty(item);
			});
			return groupedItems;
		}

		function buildPermalinkItems(items) {
			var groupedItems = buildGroupedCheckoutItems(items);
			return Object.keys(groupedItems).map(function (id) {
				return id + ":" + groupedItems[id];
			});
		}

		function buildShopifyLineItems(items) {
			var groupedItems = buildGroupedCheckoutItems(items);
			return Object.keys(groupedItems).map(function (id) {
				var numericId = parseInt(id, 10);
				return {
					id: isNaN(numericId) ? id : numericId,
					quantity: groupedItems[id]
				};
			});
		}

		function buildProductFromCard(card) {
			if (!card) return null;
			var tierIds = buildTierIdsFromCard(card);
			var tierPrices = buildTierPricesFromCard(card);
			var shipping = buildShippingFromCard(card);

			return {
				id: getTierIdByQty(tierIds, 1),
				baseId: getTierIdByQty(tierIds, 1),
				tierIds: tierIds,
				tierPrices: tierPrices,
				shippingFee: shipping.fee,
				shippingFreeFrom: shipping.freeFrom,
				name: card.getAttribute("data-name"),
				price: getTierPriceByQty(tierPrices, 1),
				img: card.getAttribute("data-img")
			};
		}

		cart = cart.map(normalizeCartItem).filter(Boolean);
		saveCart();

		function getTotalQty() {
			return cart.reduce(function (sum, item) {
				return sum + item.qty;
			}, 0);
		}

		function getLinePrice(item) {
			return getTierPriceByQty(item.tierPrices, item.qty);
		}

		function getSubtotal() {
			return cart.reduce(function (sum, item) {
				return sum + getLinePrice(item);
			}, 0);
		}

		function getShipping() {
			var subtotal = getSubtotal();
			if (subtotal <= 0) return 0;
			if (subtotal >= CART_FREE_SHIPPING_SUBTOTAL) return 0;
			return CART_SHIPPING_FEE;
		}

		function getTotal() {
			return getSubtotal() + getShipping();
		}

		function updateCount() {
			if (!countEl) return;
			var totalQty = cart.reduce(function (sum, item) {
				return sum + item.qty;
			}, 0);
			countEl.textContent = totalQty;
			countEl.classList.toggle("has-items", totalQty > 0);
		}

		function renderCart() {
			if (!itemsEl) return;

			if (!cart.length) {
				itemsEl.innerHTML = '<p class="ns-cart-empty">Votre panier est vide.</p>';
				if (footerEl) footerEl.style.display = "none";
				return;
			}

			if (footerEl) footerEl.style.display = "";
			var shipping = getShipping();
			if (subtotalEl) subtotalEl.textContent = formatPrice(getSubtotal()) + " DH";
			if (shippingEl) shippingEl.textContent = shipping === 0 ? "Gratuite" : (formatPrice(shipping) + " DH");
			if (totalEl) totalEl.textContent = formatPrice(getTotal()) + " DH";

			var html = "";
			cart.forEach(function (item, index) {
				html += '<div class="ns-cart-item">' +
					'<img class="ns-cart-item-img" src="' + item.img + '" alt="' + item.name + '">' +
						'<div class="ns-cart-item-details">' +
							'<p class="ns-cart-item-name">' + item.name + '</p>' +
							'<p class="ns-cart-item-price">' + formatPrice(getLinePrice(item)) + " DH</p>" +
						'<div class="ns-cart-item-qty">' +
							'<button class="ns-cart-qty-btn" data-action="dec" data-idx="' + index + '">&#8722;</button>' +
							'<span class="ns-cart-qty-val">' + item.qty + "</span>" +
							'<button class="ns-cart-qty-btn" data-action="inc" data-idx="' + index + '"' + (item.qty >= MAX_QTY ? " disabled" : "") + ">&#43;</button>" +
						"</div>" +
					"</div>" +
					'<button class="ns-cart-item-remove" data-idx="' + index + '" aria-label="Retirer">&#x2715;</button>' +
				"</div>";
			});
			itemsEl.innerHTML = html;

			itemsEl.querySelectorAll(".ns-cart-qty-btn").forEach(function (button) {
				button.addEventListener("click", function () {
					var index = parseInt(this.getAttribute("data-idx"), 10);
					var action = this.getAttribute("data-action");
					var item = cart[index];
					if (!item) return;
						if (action === "inc") {
							if (item.qty >= MAX_QTY) return;
							var nextQty = item.qty + 1;
							var nextId = getTierIdByQty(item.tierIds, nextQty);
							if (!nextId) return;
							item.qty = nextQty;
							item.id = nextId;
							item.price = getTierPriceByQty(item.tierPrices, item.qty);
						} else {
							var previousQty = item.qty - 1;
							if (previousQty <= 0) {
								cart.splice(index, 1);
							} else {
								var previousId = getTierIdByQty(item.tierIds, previousQty);
								if (!previousId) return;
								item.qty = previousQty;
								item.id = previousId;
								item.price = getTierPriceByQty(item.tierPrices, item.qty);
							}
						}
					saveCart();
					updateCount();
					renderCart();
				});
			});

			itemsEl.querySelectorAll(".ns-cart-item-remove").forEach(function (button) {
				button.addEventListener("click", function () {
					var index = parseInt(this.getAttribute("data-idx"), 10);
					cart.splice(index, 1);
					saveCart();
					updateCount();
					renderCart();
				});
			});
		}

		function openCart() {
			if (drawer) {
				drawer.classList.add("open");
				drawer.setAttribute("aria-hidden", "false");
			}
			if (overlay) {
				overlay.classList.add("open");
				overlay.setAttribute("aria-hidden", "false");
			}
			document.body.classList.add("ns-cart-open");
			setMobileMenu(false);
			syncBodyLock();
			renderCart();
			if (itemsEl) itemsEl.scrollTop = 0;
		}

		function closeCart() {
			if (drawer) {
				drawer.classList.remove("open");
				drawer.setAttribute("aria-hidden", "true");
			}
			if (overlay) {
				overlay.classList.remove("open");
				overlay.setAttribute("aria-hidden", "true");
			}
			document.body.classList.remove("ns-cart-open");
			syncBodyLock();
		}

		function showAddedFeedback() {
			if (openBtn) {
				openBtn.classList.remove("ns-cart-pulse");
				if (pulseTimer) window.clearTimeout(pulseTimer);
				pulseTimer = window.setTimeout(function () {
					openBtn.classList.add("ns-cart-pulse");
				}, 10);
			}

			if (!toastEl) {
				toastEl = document.createElement("div");
				toastEl.className = "ns-cart-toast";
				toastEl.textContent = "Hijab ajouté au panier";
				document.body.appendChild(toastEl);
			}

			toastEl.classList.add("show");
			if (toastTimer) window.clearTimeout(toastTimer);
			toastTimer = window.setTimeout(function () {
				toastEl.classList.remove("show");
			}, 850);
		}

		var qtyOverlay = document.getElementById("ns-qty-overlay");
		var qtyModal = document.getElementById("ns-qty-modal");
		var qtyClose = document.getElementById("ns-qty-close");
		var qtyDec = document.getElementById("ns-qty-dec");
		var qtyInc = document.getElementById("ns-qty-inc");
		var qtyVal = document.getElementById("ns-qty-val");
		var qtyTiers = document.getElementById("ns-qty-tiers");
		var qtyConfirm = document.getElementById("ns-qty-confirm");
		var qtyBuyNow = document.getElementById("ns-qty-buy-now");
		var qtyProductName = document.getElementById("ns-qty-product-name");
		var easySellProxy = document.getElementById("ns-easysell-proxy");
		var easySellProxyContainer = document.getElementById("ns-easysell-proxy-container");
		var pendingProduct = null;
		var currentQty = 1;
		var codBusy = false;

		function setLoadingState(button, loading, busyLabel) {
			if (!button) return;
			if (!button.getAttribute("data-default-label")) {
				button.setAttribute("data-default-label", button.textContent);
			}
			button.disabled = !!loading;
			button.textContent = loading ? (busyLabel || "Chargement...") : button.getAttribute("data-default-label");
		}

		function buildPendingSelection() {
			if (!pendingProduct) return null;
			var qty = currentQty;
			if (qty > MAX_QTY) qty = MAX_QTY;
			return normalizeCartItem({
				id: getTierIdByQty(pendingProduct.tierIds, qty) || pendingProduct.id,
				baseId: pendingProduct.baseId || pendingProduct.id,
				name: pendingProduct.name,
				price: getTierPriceByQty(pendingProduct.tierPrices, qty),
				img: pendingProduct.img,
				qty: qty,
				tierIds: pendingProduct.tierIds,
				tierPrices: pendingProduct.tierPrices,
				shippingFee: pendingProduct.shippingFee,
				shippingFreeFrom: pendingProduct.shippingFreeFrom
			});
		}

		function upsertCartItem(item) {
			if (!item) return false;
			var existing = cart.find(function (entry) {
				if (item.baseId) return entry.baseId === item.baseId;
				return entry.name === item.name;
			});

			if (existing) {
				existing.qty = item.qty;
				existing.id = item.id;
				existing.baseId = item.baseId || existing.baseId;
				existing.tierIds = item.tierIds;
				existing.tierPrices = item.tierPrices;
				existing.price = item.price;
				existing.shippingFee = item.shippingFee;
				existing.shippingFreeFrom = item.shippingFreeFrom;
				existing.img = item.img;
				return true;
			}

			cart.push(item);
			return true;
		}

		function syncShopifyCart(items) {
			var lineItems = buildShopifyLineItems(items);
			var requestOptions = {
				method: "POST",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json"
				}
			};

			return fetch("/cart/clear.js", requestOptions).then(function (response) {
				if (!response.ok) throw new Error("Unable to clear Shopify cart");
				if (!lineItems.length) return lineItems;

				return fetch("/cart/add.js", {
					method: "POST",
					headers: requestOptions.headers,
					body: JSON.stringify({ items: lineItems })
				}).then(function (addResponse) {
					if (!addResponse.ok) throw new Error("Unable to sync Shopify cart");
					return lineItems;
				});
			});
		}

		function triggerEasySellPopup() {
			var trigger = null;
			if (easySellProxyContainer) {
				trigger = easySellProxyContainer.querySelector(
					".es-popup-button-overwrite, .es-popup-button-product, .es-popup-button-cart, [class*='es-popup-button']"
				);
			}
			if (!trigger && easySellProxy) trigger = easySellProxy;
			if (!trigger) return false;
			trigger.click();
			return true;
		}

		function fallbackToCheckout(items) {
			var permalinkItems = buildPermalinkItems(items);
			if (permalinkItems.length > 0) {
				window.location.href = "/cart/" + permalinkItems.join(",");
				return;
			}
			window.location.href = "/cart";
		}

		function openEasySellForItems(items, triggerButton, busyLabel, onBeforePopup) {
			if (codBusy) return;
			if (!window.fetch) {
				fallbackToCheckout(items);
				return;
			}
			codBusy = true;
			setLoadingState(triggerButton, true, busyLabel);

			syncShopifyCart(items).then(function () {
				if (typeof onBeforePopup === "function") onBeforePopup();
				if (!triggerEasySellPopup()) fallbackToCheckout(items);
			}).catch(function () {
				fallbackToCheckout(items);
			}).finally(function () {
				codBusy = false;
				setLoadingState(triggerButton, false);
			});
		}

		function highlightTier(qty) {
			if (!qtyTiers) return;
			qtyTiers.querySelectorAll("li").forEach(function (li) {
				var tierQty = parseInt(li.getAttribute("data-qty"), 10);
				li.classList.toggle("is-active", tierQty === qty);
			});
		}

		function setQty(qty) {
			if (qty < 1) qty = 1;
			if (qty > MAX_QTY) qty = MAX_QTY;
			currentQty = qty;
			if (qtyVal) qtyVal.textContent = String(qty);
			highlightTier(qty);
		}

		function renderQtyTierPrices(product) {
			if (!qtyTiers || !product) return;
			qtyTiers.querySelectorAll("li").forEach(function (li) {
				var tierQty = parseInt(li.getAttribute("data-qty"), 10);
				if (isNaN(tierQty)) return;
				var tierPrice = getTierPriceByQty(product.tierPrices, tierQty);
				var priceEl = li.querySelector(".ns-tier-p");
				var shippingEl = li.querySelector(".ns-tier-s");
				if (priceEl) priceEl.textContent = formatPrice(tierPrice) + " DH";
				if (shippingEl) shippingEl.textContent = getShippingLabelForQty(product, tierQty);
			});
		}

		function openQtyModal(product) {
			pendingProduct = product;
			if (qtyProductName) qtyProductName.textContent = product.name;
			renderQtyTierPrices(product);
			setQty(1);
			if (qtyOverlay) {
				qtyOverlay.classList.add("open");
				qtyOverlay.setAttribute("aria-hidden", "false");
			}
			if (qtyModal) {
				qtyModal.classList.add("open");
				qtyModal.setAttribute("aria-hidden", "false");
			}
			document.body.classList.add("ns-qty-open");
		}

		function closeQtyModal() {
			if (qtyOverlay) {
				qtyOverlay.classList.remove("open");
				qtyOverlay.setAttribute("aria-hidden", "true");
			}
			if (qtyModal) {
				qtyModal.classList.remove("open");
				qtyModal.setAttribute("aria-hidden", "true");
			}
			document.body.classList.remove("ns-qty-open");
			pendingProduct = null;
		}

		if (qtyDec) qtyDec.addEventListener("click", function () { setQty(currentQty - 1); });
		if (qtyInc) qtyInc.addEventListener("click", function () { setQty(currentQty + 1); });
		if (qtyClose) qtyClose.addEventListener("click", closeQtyModal);
		if (qtyOverlay) qtyOverlay.addEventListener("click", closeQtyModal);
		if (qtyTiers) {
			qtyTiers.querySelectorAll("li").forEach(function (li) {
				li.addEventListener("click", function () {
					var tierQty = parseInt(li.getAttribute("data-qty"), 10);
					if (!isNaN(tierQty)) setQty(tierQty);
				});
			});
		}
		if (qtyConfirm) {
			qtyConfirm.addEventListener("click", function () {
				var selection = buildPendingSelection();
				if (!selection) return;
				upsertCartItem(selection);
				saveCart();
				updateCount();
				showAddedFeedback();
				closeQtyModal();
			});
		}

		if (qtyBuyNow) {
			qtyBuyNow.addEventListener("click", function () {
				var selection = buildPendingSelection();
				if (!selection) return;
				openEasySellForItems([selection], qtyBuyNow, "Ouverture du formulaire...", closeQtyModal);
			});
		}

		function bindPurchaseButtons() {
			document.querySelectorAll("[data-purchase='true']").forEach(function (button) {
				button.addEventListener("click", function () {
					var card = this.closest("[data-name][data-price][data-img]");
					if (!card) return;
					var product = buildProductFromCard(card);
					if (!product) return;
					openQtyModal(product);
				});
			});
		}

		var checkoutBtn = document.querySelector(".ns-checkout-btn");
		if (checkoutBtn) {
			checkoutBtn.addEventListener("click", function() {
				if (!cart.length) {
					window.location.href = "/cart";
					return;
				}
				openEasySellForItems(cart.slice(), checkoutBtn, "Ouverture du formulaire...", closeCart);
			});
		}

		if (openBtn) openBtn.addEventListener("click", openCart);
		if (closeBtn) closeBtn.addEventListener("click", closeCart);
		if (overlay) overlay.addEventListener("click", closeCart);

		updateCount();
		renderCart();
		bindPurchaseButtons();
	}

	function initStories() {
		var section = document.getElementById("section-nos-couleurs");
		var viewport = document.getElementById("ns-stories-viewport");
		var track = section && section.querySelector(".ns-stories-track");
		var prevBtn = document.getElementById("ns-story-prev");
		var nextBtn = document.getElementById("ns-story-next");
		if (!section || !viewport || !track) return;

		var slides = Array.prototype.slice.call(section.querySelectorAll(".ns-story-card"));
		var progressItems = Array.prototype.slice.call(section.querySelectorAll(".ns-story-progress-item"));
		var currentIndex = 0;
		var sectionInView = !("IntersectionObserver" in window);
		var scrollTimer = 0;
		var programmaticScrollTimer = 0;
		var isProgrammaticScroll = false;

		function normalizeIndex(index) {
			if (index < 0) return slides.length - 1;
			if (index >= slides.length) return 0;
			return index;
		}

		function setProgress(index, value) {
			var fill = progressItems[index] && progressItems[index].querySelector(".ns-story-progress-fill");
			if (!fill) return;
			fill.style.transform = "scaleX(" + value + ")";
		}

		function updateCompletedProgress() {
			slides.forEach(function (_, index) {
				if (index < currentIndex) setProgress(index, 1);
				else if (index > currentIndex) setProgress(index, 0);
			});
		}

		function pauseInactiveVideos() {
			slides.forEach(function (slide, index) {
				var video = slide.querySelector(".ns-story-video");
				if (!video || index === currentIndex) return;
				video.pause();
				video.currentTime = 0;
			});
		}

		function playActiveVideo(fromStart) {
			var activeSlide = slides[currentIndex];
			if (!activeSlide) return;

			var video = activeSlide.querySelector(".ns-story-video");
			if (!video) return;

			if (fromStart) {
				video.currentTime = 0;
				setProgress(currentIndex, 0);
			}

			if (!sectionInView || prefersReducedMotion) return;

			var playPromise = video.play();
			if (playPromise && typeof playPromise.catch === "function") {
				playPromise.catch(function () {});
			}
		}

		function updateTrackPadding() {
			var referenceSlide = slides[0];
			if (!referenceSlide) return 0;

			var slideWidth = referenceSlide.offsetWidth;
			var sidePadding = Math.max((viewport.clientWidth - slideWidth) / 2, 0);
			track.style.setProperty("--story-side-pad", sidePadding + "px");
			return sidePadding;
		}

		function getCenteredScrollLeft(index) {
			var slide = slides[index];
			if (!slide) return 0;

			var targetLeft = slide.offsetLeft - ((viewport.clientWidth - slide.offsetWidth) / 2);
			var maxScrollLeft = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
			return Math.max(0, Math.min(targetLeft, maxScrollLeft));
		}

		function scrollToSlide(index, immediate) {
			isProgrammaticScroll = true;
			viewport.scrollTo({
				left: getCenteredScrollLeft(index),
				behavior: (prefersReducedMotion || immediate) ? "auto" : "smooth"
			});
			window.clearTimeout(programmaticScrollTimer);
			programmaticScrollTimer = window.setTimeout(function () {
				isProgrammaticScroll = false;
			}, (prefersReducedMotion || immediate) ? 0 : 420);
		}

		function goTo(index, options) {
			var opts = options || {};
			currentIndex = normalizeIndex(index);

			slides.forEach(function (slide, slideIndex) {
				var active = slideIndex === currentIndex;
				slide.classList.toggle("is-active", active);
				slide.setAttribute("aria-hidden", active ? "false" : "true");
			});

			progressItems.forEach(function (item, itemIndex) {
				item.classList.toggle("is-active", itemIndex === currentIndex);
			});

			updateCompletedProgress();
			pauseInactiveVideos();

			if (!opts.skipScroll) scrollToSlide(currentIndex);
			playActiveVideo(opts.resume !== true);
		}

		function findNearestSlideIndex() {
			var viewportRect = viewport.getBoundingClientRect();
			var viewportCenter = viewportRect.left + (viewportRect.width / 2);
			var nearestIndex = currentIndex;
			var smallestDistance = Number.POSITIVE_INFINITY;

			slides.forEach(function (slide, index) {
				var rect = slide.getBoundingClientRect();
				var slideCenter = rect.left + (rect.width / 2);
				var distance = Math.abs(viewportCenter - slideCenter);
				if (distance < smallestDistance) {
					smallestDistance = distance;
					nearestIndex = index;
				}
			});

			return nearestIndex;
		}

		slides.forEach(function (slide, index) {
			var video = slide.querySelector(".ns-story-video");
			if (!video) return;

			video.addEventListener("timeupdate", function () {
				if (index !== currentIndex || !video.duration) return;
				setProgress(index, Math.min(video.currentTime / video.duration, 1));
			});

			video.addEventListener("ended", function () {
				if (index !== currentIndex) return;
				setProgress(index, 1);
				goTo(currentIndex + 1);
			});
		});

		progressItems.forEach(function (item, index) {
			item.addEventListener("click", function () {
				goTo(index);
			});
		});

		if (prevBtn) {
			prevBtn.addEventListener("click", function () {
				goTo(currentIndex - 1);
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener("click", function () {
				goTo(currentIndex + 1);
			});
		}

		viewport.addEventListener("scroll", function () {
			if (isProgrammaticScroll) return;
			window.clearTimeout(scrollTimer);
			scrollTimer = window.setTimeout(function () {
				var nearestIndex = findNearestSlideIndex();
				if (nearestIndex !== currentIndex) {
					goTo(nearestIndex, { skipScroll: true });
				}
			}, 90);
		}, { passive: true });

		window.addEventListener("resize", function () {
			window.clearTimeout(window.__nsStoriesResizeTimer);
			window.__nsStoriesResizeTimer = window.setTimeout(function () {
				updateTrackPadding();
				scrollToSlide(currentIndex, true);
			}, 120);
		});

		if ("IntersectionObserver" in window && !prefersReducedMotion) {
			var storyObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					sectionInView = entry.isIntersecting;
					var activeVideo = slides[currentIndex] && slides[currentIndex].querySelector(".ns-story-video");
					if (!activeVideo) return;

					if (sectionInView) {
						var playPromise = activeVideo.play();
						if (playPromise && typeof playPromise.catch === "function") {
							playPromise.catch(function () {});
						}
					} else {
						activeVideo.pause();
					}
				});
			}, {
				threshold: 0.42
			});

			storyObserver.observe(section);
		}

		updateTrackPadding();
		goTo(0, { skipScroll: true });
		scrollToSlide(0, true);
	}

	document.addEventListener("DOMContentLoaded", function () {
		initHeroLogoPosition();
		initHero();
		initMobileMenu();
		initSmoothScroll();
		initReveals();
		initHeaderContrast();
		initRotators();
		initCart();
		initStories();
	});
})();
